export interface AppConfig {
  chatURL: string;
  kibanaURL: string;
}

const defaultAppConfig: AppConfig = {
  chatURL: '',
  kibanaURL: '',
};

export const appConfig: AppConfig = { ...defaultAppConfig };

export async function loadAppConfig(): Promise<void> {
  try {
    const response = await fetch('assets/config.json', { cache: 'no-cache' });
    if (!response.ok) {
      console.error(`[AppConfig] Failed to load assets/config.json: HTTP ${response.status} ${response.statusText}`);
      return;
    }
    const config = (await response.json()) as Partial<AppConfig>;
    Object.assign(appConfig, defaultAppConfig, config);
  } catch (error) {
    console.error('[AppConfig] Failed to load assets/config.json:', error);
    Object.assign(appConfig, defaultAppConfig);
  }
}
